import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../constants/text';
import { colors } from '../../constants/colors';
import { smallerThan } from '../../core/util/styledComponents';
import SectionTitle from './SectionTitle';

const Root = styled.div`
  text-align: center;

  ${smallerThan.tablet`
    padding: 0 15px;
  `}
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  max-width: 1000px;
  margin: 20px auto;
`;

const Card = styled.div`
  flex-shrink: 0;
  flex-grow: 1;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 20px;
  max-width: 300px;
`;

const CardImage = styled.img`
  display: block;
  height: 150px;
  margin: 0 auto;
`;

const CardTitle = styled.p`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.medium};
  color: ${colors.squid};
  margin: 23px auto 14px;
`;

const CardCopy = styled.p`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  color: ${colors.blueMonday};
`;

const BenefitsSection = () => {
  return (
    <Root>
      <SectionTitle>Convenient care around the corner, around the clock</SectionTitle>

      <CardContainer>
        <Card>
          <CardImage alt="No Paper Forms" src="/images/homepage/Benefits/Form.svg" />
          <CardTitle>Quick and easy</CardTitle>
          <CardCopy>No paperwork for breezy booking, with texts to keep you up-to-date.</CardCopy>
        </Card>
        <Card>
          <CardImage alt="Near You" src="/images/homepage/Benefits/Building.svg" />
          <CardTitle>In your neighborhood</CardTitle>
          <CardCopy>
            Great healthcare professionals who treat you like a neighbor (because they are).
          </CardCopy>
        </Card>

        <Card>
          <CardImage alt="Upload Insurance" src="/images/homepage/Benefits/Insurance.svg" />
          <CardTitle>Know what's covered</CardTitle>
          <CardCopy>
            Snap a photo of your insurance card to see your benefits ahead of time.
          </CardCopy>
        </Card>
      </CardContainer>
    </Root>
  );
};

export default BenefitsSection;
